import { render, staticRenderFns } from "./DappDetailedTablesSection.vue?vue&type=template&id=3f61be60&scoped=true"
import script from "./DappDetailedTablesSection.vue?vue&type=script&lang=ts"
export * from "./DappDetailedTablesSection.vue?vue&type=script&lang=ts"
import style0 from "./DappDetailedTablesSection.vue?vue&type=style&index=0&id=3f61be60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f61be60",
  null
  
)

export default component.exports